import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Welcome from '../views/welcome.vue'
import HuodongList from '../views/huodong/list.vue'
import ZixunList from '../views/zixun/list.vue'
import EditHuodong from '../views/huodong/edit.vue'
import AddHuodong from '../views/huodong/add.vue'

import EditZixun from '../views/zixun/edit.vue'
import AddZixun from '../views/zixun/add.vue'

import Login from '../views/Login.vue'

import Shouye from '../views/shouye/shouye.vue'

import AddVideo from '../views/shouye/addVideo.vue'

import JianJie from '../views/jianjie/jianjie.vue'
import AddZigongsi from '../views/jianjie/addZigongsi.vue'
import EditZigongsi from '../views/jianjie/editZigongsi.vue'
import AddFazhan from '../views/jianjie/addFazhan.vue'
import EditFazhan from '../views/jianjie/editFazhan.vue'
import addRongYu from '../views/jianjie/addRongYu.vue'
import editRongYu from '../views/jianjie/editRongYu.vue'

import Pinpai from '../views/pinpai/pinpai.vue'
import Lianxiwomen from '../views/lianxiwomen/lianxiwomen.vue'
import AddJob from '../views/lianxiwomen/addJob.vue'
import EditJob from '../views/lianxiwomen/editJob.vue'
import EditHuangjing from '../views/lianxiwomen/editHuangjingtupian.vue'

Vue.use(VueRouter)

  const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  /* { path: '/', redirect: '/home' }, */
  {
    path: '/',
    name: 'Home',
    component: Home,
	redirect:'/Welcome',
	children:[
		{ path: '/home', component: Welcome },
		{ path: '/huodonglist', component: HuodongList},
		{ path: '/zixunlist', component: ZixunList},
		{ path: '/edithuodong', component: EditHuodong },
		{ path: '/addhuodong', component: AddHuodong },
		{ path: '/editzixun', component: EditZixun },
		{ path: '/addzixun', component: AddZixun },
		{ path: '/shoye', component: Shouye },
		{ path: '/shoyeaddvideo', component: AddVideo },
		{ path: '/jianjie', component: JianJie },
		{ path: '/addzigongsi', component: AddZigongsi },
		{ path: '/editzigongsi', component: EditZigongsi },
		{ path: '/addfazhan', component: AddFazhan },
		{ path: '/editfazhan', component: EditFazhan },
		{ path: '/addrongyu', component: addRongYu },
		{ path: '/editrongyu', component: editRongYu },
		{ path: '/pinpai', component: Pinpai },
		{ path: '/lianxiwomen', component: Lianxiwomen },
		{ path: '/addjob', component: AddJob },
		{ path: '/editjob', component: EditJob },
		{ path: '/edithuanjingtupian', component: EditHuangjing },
	]
  }
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  // 访问登录页，放行
  if (to.path === '/login') return next()
  // 获取token
  const tokenStr = window.sessionStorage.getItem('jiuhangtoken')
  // 没有token, 强制跳转到登录页
  if (!tokenStr) return next('/login')
  next()
})

export default router
